export default __webpack_public_path__ + "static/media/HealthInsurance.9f73a0cb.svg";